var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('router-link',{staticClass:"ai-entry",attrs:{"to":{ path: '/ai', query: { from: _vm.$route.fullPath } }}},[_c('ai-icon',{attrs:{"name":"spark"}}),_c('ai-name')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }